import { FormControl } from '@material-ui/core';
import { useCallback } from 'react';
import { WbTextField } from '../WbTextField';
import { FieldActions } from './FieldActions';
import { useGeneralPurposePickerContext } from './GeneralPurposePickerContext';
import { BaseProps, KindEnum, TextFieldValue } from './types';

export const SingleTextField = ({
  title,
  description,
  freeSolo,
  required,
  disabled,
  value,
  selectableEntities,
  ...props
}: {
  title: string;
  description?: string | undefined;
  freeSolo: boolean;
  required: boolean;
  disabled: boolean;
  value?: TextFieldValue;
  selectableEntities: number;
} & BaseProps) => {
  const { setSelectedValues, setOpenDialog } = useGeneralPurposePickerContext();

  const onClear = useCallback(() => {
    setSelectedValues({ tableValues: [], arbitraryValues: [] });
  }, [setSelectedValues]);

  const adaptValue = (option: TextFieldValue) => {
    if (option.kind === KindEnum.arbitrary || option.kind === KindEnum.policy)
      return option.label;
    const labelKind = option?.kindDisplayName ?? option?.kind;

    return `${labelKind && selectableEntities > 1 ? `${labelKind}:` : ''}  ${
      value?.label ? value?.label : ''
    }`;
  };

  const helperText = description;

  return (
    <FormControl required={required}>
      <WbTextField
        label={title}
        required={required}
        value={value ? adaptValue(value) : undefined}
        disabled={disabled}
        helperText={helperText}
        onChange={e => {
          const targetValue = e.target.value;
          const arbitraryValue =
            targetValue !== ''
              ? [
                  {
                    label: targetValue,
                    value: targetValue,
                    kind: KindEnum.arbitrary,
                  },
                ]
              : undefined;
          setSelectedValues({
            tableValues: [],
            arbitraryValues: arbitraryValue,
          });
        }}
        onClick={() => {
          if (!freeSolo) {
            setOpenDialog(true);
          }
        }}
        InputProps={{
          readOnly: !freeSolo,
          endAdornment: !disabled ? (
            <FieldActions
              onClear={onClear}
              onOpen={() => setOpenDialog(true)}
            />
          ) : undefined,
        }}
        {...props}
      />
    </FormControl>
  );
};
